import React from 'react';
import '../template-file-css/document-file-template.css';


export const PBS_ChildAdolescentAssessment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='PBS_ChildAdolescentAssessment' className='file-pdf-document'>
            <div className='file-template w-750'>
 
 

<table>
    <tr>
        <td className='w-250'>
            <span className='eleHeader'>Treatment Planning Date:</span>
            <input type="date" id="txtPlanningDate" name="txtPlanningDate" className='add-only' />
        </td>
          <td className='w-250'>
            <span className='eleHeader'>Staff Completing IRP:</span>
            <input type="text" id="txtStaffCompleting" name="txtStaffCompleting" className='add-only' />
        </td>
           <td className='w-250'>
            <span className='eleHeader'>Location:</span>
            <input type="text" id="txtLocation" name="txtLocation" className='add-only' />
        </td>
    </tr>
</table>

<p>
     <span className='eleHeader'>Behavior:</span>
     <textarea id="txtBehavior" name="txtBehavior" className='add-only'>The individual presented today with a X affect, and X demeanor, while the individual continues to appear X.</textarea>
</p>
<p>
     <span className='eleHeader'>Intervention:</span>
     <textarea id="txtIntervention" name="txtIntervention" className='add-only'>The X described the purpose of today's meeting was to plan her/his projected course of treatment services. </textarea>
</p>
<p>
     <span className='eleHeader'>Response:</span>
     <textarea id="txtResponse" name="txtResponse" className='add-only'>S/he appeared x during the treatment planning meeting, but reported a history of X.  X shared how he/she would like to x. </textarea>
</p>
<p>
     <span className='eleHeader'>Plan:</span>
     <textarea id="txtPlan" name="txtPlan" className='add-only'>Therapy (Clinician's name, if known), and Psychosocial Rehabilitation and Case Management Services Staff X, PP will contact the individual /(guardian) within one week to schedule X's first appointments.  The Administrative Assistant will schedule medication and nursing appointments.. </textarea>
</p>

<h3><center>Term of Plan</center></h3>
<table>
     <tr>
        <td className='w-375'>
            <span className='eleHeader'>Start Date</span>
            <input type="date" id="txtStartDate" name="txtStartDate" className='add-only' />
        </td>
          <td className='w-375'>
            <span className='eleHeader'>End Date</span>
            <input type="date" id="txtEndDate" name="txtEndDate" className='add-only' />
        </td>
    </tr>
</table>

<p>
     <span className='eleHeader' >Diagnosis:</span>
     <textarea id="txtDiagnosis" name="txtDiagnosis" className='add-only'></textarea>
</p>

<h3><center>Therapeutic Goals</center></h3>
<h4><center>PLEASE ADDRESS ALL PRESENTING PROBLEMS (MAY NOT NEED TO USE ALL GOALS OR OBJECTIVE PROMPTS BELOW)!</center></h4>

<p>
     <span className='eleHeader'>Goal  1</span>
     <textarea id="txtGoal_1" name="txtGoal_1" className='add-only'></textarea>
</p>
<p>
     <span className='eleHeader'>Objective  1</span>
     <textarea id="txtObjective_1" name="txtObjective_1" className='add-only'>The individual will talk with X about his/her health, family, placement/homelife, feelings/moods, thinking, behavior, substance use, school, legal status, activities, and relationship history, within 3 months</textarea>
</p>
<p>
     <span className='eleHeader'>Intervention  1</span>
     <textarea id="txtIntervention_1" name="txtIntervention_1" className='add-only'>Keep this section if needed: Psychiatric assessment services will discuss with the individual his/her medical and behavioral health, his/her about diagnoses/symptoms, and how the medications can work</textarea>
</p>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Frequency</span>
            <input type="text" id="txtFrequency_1" name="txtFrequency_1" className='add-only'/>
        </td>
    </tr>
</table>
<p>
     <span className='eleHeader'>Intervention  2</span>
     <textarea id="txtIntervention_2" name="txtIntervention_2" className='add-only'>Behavioral health assessment services will guide the individual in talking about history</textarea>
</p>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Frequency</span>
            <input type="text" id="txtFrequency_2" name="txtFrequency_2" className='add-only'/>
        </td>
    </tr>
</table>
<p>
     <span className='eleHeader'>Intervention  3</span>
     <textarea id="txtIntervention_3" name="txtIntervention_3" className='add-only'>Service plan development services will guide the individual in voicing thoughts about areas in which he needs help  </textarea>
</p>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Frequency</span>
            <input type="text" id="txtFrequency_3" name="txtFrequency_3" className='add-only' />
        </td>
    </tr>
</table>
<p>
     <span className='eleHeader'>Intervention  4</span>
     <textarea id="txtIntervention_4" name="txtIntervention_4" className='add-only'>Nursing services will monitor the individual's basic health care.specify if any medical conditions</textarea>
</p>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Frequency</span>
            <input type="text" id="txtFrequency_4" name="txtFrequency_4" className='add-only' />
        </td>
    </tr>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Target Date</span>
            <input type="date" id="txtTargetDate_1" name="txtTargetDate_1" className='add-only'/>
        </td>
    </tr>
</table>
<p>
     <span className='eleHeader'>Goal  2</span>
     <textarea id="txtGoal_2" name="txtGoal_2" className='add-only'></textarea>
</p>
<p>
     <span className='eleHeader'>Objective  2</span>
     <textarea id="txtObjective_2" name="txtObjective_2" className='add-only'></textarea>
</p>
<p>
     <span className='eleHeader'>Intervention  1</span>
     <textarea id="txtIntervention_5" name="txtIntervention_5" className='add-only'>Individual therapy services will discuss with the individual</textarea>
</p>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Frequency</span>
            <input type="text" id="txtFrequency_5" name="txtFrequency_5" className='add-only' />
        </td>
    </tr>
</table>
<p>
     <span className='eleHeader'>Intervention  2</span>
     <textarea id="txtIntervention_6" name="txtIntervention_6" className='add-only'>Psychosocial rehabilitation services-individual will teach or train the individual</textarea>
</p>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Frequency</span>
            <input type="text" id="txtFrequency_6" name="txtFrequency_6" className='add-only'/>
        </td>
    </tr>
</table>
<p>
     <span className='eleHeader'>Intervention  3</span>
     <textarea id="txtIntervention_7" name="txtIntervention_7" className='add-only'>Case management services will connect the individual </textarea>
</p>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Frequency</span>
            <input type="text" id="txtFrequency_7" name="txtFrequency_7" className='add-only' />
        </td>
    </tr>
</table>
<p>
     <span className='eleHeader'>Intervention  4</span>
     <textarea id="txtIntervention_8" name="txtIntervention_8" className='add-only'>Family therapy services will discuss with the family</textarea>
</p>
<table>
     <tr>
        <td className='w-750'>
            <span className='eleHeader'>Frequency</span>
            <input type="text" id="txtFrequency_8" name="txtFrequency_8" className='add-only'/>
        </td>
    </tr>
</table>
<p>
     <span className='eleHeader'>Intervention  5</span>
     <textarea id="txtIntervention_9" name="txtIntervention_9" className='add-only'>Family outpatient services will provide family skills training</textarea>
</p>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Frequency</span>
            <input type="text" id="txtFrequency_9" name="txtFrequency_9" className='add-only'/>
        </td>
    </tr>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Target Date</span>
            <input type="date" id="txtTargetDate_2" name="txtTargetDate_2" className='add-only'/>
        </td>
    </tr>
</table>

<p>
     <span className='eleHeader'>Goal  3</span>
     <textarea id="txtGoal_3" name="txtGoal_3" className='add-only'></textarea>
</p>
<p>
     <span className='eleHeader'>Objective  2</span>
     <textarea id="txtObjective_3" name="txtObjective_3" className='add-only'></textarea>
</p>
<p>
     <span className='eleHeader'>Intervention  1</span>
     <textarea id="txtIntervention_10" name="txtIntervention_10" className='add-only'>Individual therapy services will discuss with the individual</textarea>
</p>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Frequency</span>
            <input type="text" id="txtFrequency_10" name="txtFrequency_10" className='add-only' />
        </td>
    </tr>
</table>
<p>
     <span className='eleHeader'>Intervention  2</span>
     <textarea id="txtIntervention_11" name="txtIntervention_11" className='add-only'>Psychosocial rehabilitation services-individual will teach or train the individual</textarea>
</p>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Frequency</span>
            <input type="text" id="txtFrequency_11" name="txtFrequency_11" className='add-only' />
        </td>
    </tr>
</table>
<p>
     <span className='eleHeader'>Intervention  3</span>
     <textarea id="txtIntervention_12" name="txtIntervention_12" className='add-only'>Case management services will connect the individual </textarea>
</p>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Frequency</span>
            <input type="text" id="txtFrequency_12" name="txtFrequency_12" className='add-only' />
        </td>
    </tr>
</table>
<p>
     <span className='eleHeader'>Intervention  4</span>
     <textarea id="txtIntervention_13" name="txtIntervention_13" className='add-only'>Family therapy services will discuss with the family</textarea>
</p>
<table>
     <tr>
        <td className='w-750'>
            <span className='eleHeader'>Frequency</span>
            <input type="text" id="txtFrequency_13" name="txtFrequency_13" className='add-only'/>
        </td>
    </tr>
</table>
<p>
     <span className='eleHeader'>Intervention  5</span>
     <textarea id="txtIntervention_14" name="txtIntervention_14" className='add-only'>Family outpatient services will provide family skills training</textarea>
</p>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Frequency</span>
            <input type="text" id="txtFrequency_14" name="txtFrequency_14" className='add-only' />
        </td>
    </tr>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Target Date</span>
            <input type="date" id="txtTargetDate_3" name="txtTargetDate_3" className='add-only'/>
        </td>
    </tr>
</table>

<h2><center>SNAP</center></h2>
<h3><center>Individual's Strengths, Needs, Abilities, And Preferences</center></h3>
<p>
    <span className='eleHeader'>Strengths: </span>
     <textarea id="txtStrengths" name="txtStrengths" className='add-only'></textarea>
</p>
<p>
    <span className='eleHeader'>Needs: </span>
     <textarea id="txtNeeds" name="txtNeeds" className='add-only'></textarea>
</p>
<p>
    <span className='eleHeader'>Abilities: </span>
     <textarea id="txtAbilities" name="txtAbilities" className='add-only'></textarea>
</p>
<p>
    <span className='eleHeader'>Preferences: </span>
     <textarea id="txtPreferences" name="txtPreferences" className='add-only'></textarea>
</p>

<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Date of Expected Transition/Discharge </span>
            <input type="date" id="txtDischarge" name="txtDischarge" className='add-only'/>
        </td>
    </tr>
</table>

<p>
    <span className='eleHeader'>Plan</span>
     <textarea id="txtPlan_1" name="txtPlan_1" className='add-only'></textarea>
</p>

  <h3><center>Safety Plan</center></h3>
<table>
    <tr>
        <td className='w-250'><span><strong>OGCC BHS Main Office</strong></span></td>
        <td className='w-500'><input type="text" id="txtMainOffice" name="txtMainOffice" className='add-only' defaultValue={404-691-3270} /></td>
    </tr>
    <tr>
        <td className='w-250'><span><strong>After Hours On-Call Staff Member</strong></span></td>
        <td className='w-500'><input type="text" id="txtStaffMember" name="txtStaffMember" className='add-only' defaultValue={404-645-9440} /></td>
    </tr>
     <tr>
        <td className='w-250'><span><strong>Therapist</strong></span></td>
        <td className='w-500'><input type="text" id="txtTherapist" name="txtTherapist" className='add-only' defaultValue={404-691-3303} /></td>
    </tr>
     <tr>
        <td className='w-250'><span><strong>Psychiatric Nurse</strong></span></td>
        <td className='w-500'><input type="text" id="txtPsychiatric" name="txtPsychiatric" className='add-only' defaultValue={770-722-2170} /></td>
    </tr>
    <tr>
        <td className='w-250'><span><strong>Behavioral Health Link/Mobile Crisis</strong></span></td>
        <td className='w-500'><input type="text" id="txtBehavioral" name="txtBehavioral" className='add-only' defaultValue={800-715-4225} /></td>
    </tr>
     <tr>
        <td className='w-250'><span><strong>Other:</strong></span></td>
        <td className='w-500'><input type="text" id="txtOther" name="txtOther" className='add-only'/></td>
    </tr>
</table>

<p>
Note: Should Individual express suicidal/homicidal ideations (thoughts) with a plan 
<strong>PLEASE TAKE THE FOLLOWING STEPS:</strong> <br />

1.  Call the on call staff at the above number<br />

2.   When prompted by on call staff –make call to Behavioral Health Link/Mobile Crisis for assistance. <br />

3.  Should the Crisis Mobile Team come to location to assess the individual and the determination is made for hospitalization, an adult must be prepared to travel with the individual and have the necessary information i.e.  Medicaid no., current medications and diagnosis.<br /><br />

<strong>When a Suicidal/Homicidal Attempt is made PLEASE CALL 911 IMMEDIATELY and secondly notifies the on call staff and program director.</strong> 
</p>

<p>
    <span className='eleHeader'>Possible Triggers </span>
     <textarea id="txtPossibleTriggers" name="txtPossibleTriggers" className='add-only'></textarea>
</p>
<p>
    <span className='eleHeader'>Emotional and/or Behavioral Needs</span>
     <textarea id="txtBehavioralNeeds" name="txtBehavioralNeeds" className='add-only'></textarea>
</p>
<p>
    <span className='eleHeader'>Additional Comments:</span>
     <textarea id="txtAdditional" name="txtAdditional" className='add-only'></textarea>
</p>

<h3>Clinician: </h3>
<table>
     <tr>
        <td className='w-250'>
            <span className='eleHeader'>Typed/Printed Name: </span>
            <input type="text" id="txtPrintedName_1" name="txtPrintedName_1" className='add-only' />
        </td>
         <td className='w-250'>
            <span className='eleHeader'>NPI</span>
            <input type="text" id="txtNPI" name="txtNPI" className='add-only' />
        </td>
           <td className='w-250'>
            <span className='eleHeader'>Date</span>
            <input type="date" id="txtDate_1" name="txtDate_1" className='add-only' />
        </td>
    </tr>
</table>
<table>
     <tr>
        <td className='signature w-375'>
        </td>
        <td className='signature w-375'>
        </td>
    </tr>
    <tr>
        <td className='small w-375'>Signature: 
        </td>
         <td className='small w-375'>Date
        </td>
    </tr>
</table>
<h3>Individual or Parent/Guardian</h3>
<table>
     <tr>
        <td className='w-375'>
            <span className='eleHeader'>Typed/Printed Name: </span>
            <input type="text" id="txtPrintedName_2" name="txtPrintedName_2" className='add-only' />
        </td>
        <td className='w-375'>
            <span className='eleHeader'>Date</span>
            <input type="date" id="txtDate_2" name="txtDate_2" className='add-only' />
        </td>
    </tr>
</table>
<table>
     <tr>
        <td className='signature w-375'>
        </td>
        <td className='signature w-375'>
        </td>
    </tr>
    <tr>
        <td className='small w-375'>Signature: 
        </td>
         <td className='small w-375'>Date
        </td>
    </tr>
</table>


            </div>
        </form>

    )
}  
